module.exports = __webpack_public_path__ + "static/media/redis.6b881302.svg";